import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// 初始化路由
const routes = [
  {
    path: '/',
    redirect: '/home',
  },
  // {
  //   path: '/dchouse',
  //   redirect: '/dchouse/home',
  // },
  {
    path: "/home",
    name: 'Home',
    component: () => import('../view/home/Home'),
    meta:{
      title:"Home"
    }
  },
  {
    path: "/email",
    name: 'Email',
    component: () => import('@/view/email/Email.vue'),
    meta:{
      title:"Email"
    }
  },
  {
    path: "/service",
    name: 'Service',
    component: () => import('@/view/service/Service.vue'),
    meta:{
      title:"Service"
    }
  },
  {
    path: "/repair",
    name: 'Repair',
    component: () => import('@/view/repair/Repair.vue'),
    meta:{
      title:"Repair"
    }
  }
]

const router = new Router({
  mode: 'history',
  base: '/dchouse/',
  routes
})


router.afterEach((to, from) => {
  //在全局后置守卫中获取路由元信息设置title
  document.title = to.meta.title
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js